import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { sortByMonthChartData } from '../../../utils/functionUtils';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const NPSReport = ({
  chartReportCountSuccess,
  reportName,
  getBgColor
}) => {

  const options = {
    plugins: {
      title: {
        display: true,
        text: reportName,align: 'start',
        font: {
          size: 20,
        },
        padding: {
          bottom: 30
        }
      },
      legend: {
        display: false,
      },
      datalabels: {
        formatter: function (value, context) {
          // return value > 0 ? value+'%' : null;
        },
        align: "top",
        anchor: "end",
        labels: {
          usePointStyle: true,
          font: {
            weight: 700,
            color: 'black',
            size: 16,
          }
        },
      }
    },
    responsive: true,
    scales: {
      x: {
        stacked: false,
        grid: {
          display:false
        }
      },
      y: {
        stacked: false,
        grid: {
          display:false
        }
      },
    },
    barThickness: 15
  };

  const sortNPSCount = sortByMonthChartData(chartReportCountSuccess['NPSCount']);

  const npsReportCount = {
    Months: sortNPSCount?.map(v => v?.Month),
    ['OnlineNpsCount']: sortNPSCount?.map(v => v?.['OnlineNpsCount']),
    // ['Promoters']: sortNPSCount?.map(v => v?.['Promoters']),
    // ['Detractors']: sortNPSCount?.map(v => v?.['Detractors']),
    // ['Passive']: sortNPSCount?.map(v => v?.['Passive']),
  }
  const _OnlineNpsCount = {['OnlineNpsCount']: npsReportCount?.OnlineNpsCount?.map(v => {return String(v)?.includes('.') ? String(v)?.split('.')?.[0] : v})};
  
  let labels = npsReportCount?.Months

  const sorter = (a, b) => {
    a = a.split("-");
    b = b.split("-");
    if (a[0] !== b[0]) {
      return a[0] - b[0];
    } else {
      return a[1] - b[1];
    }
  };

  // let npsLabel = ['Promoters', 'Detractors', 'Passive']
  let npsLabel = ['OnlineNpsCount']

  let _reportData = []
  for (let i = 0; i < (npsLabel.length); i++) {
    _reportData.push({
      label: npsLabel[i],
      // data: npsReportCount[npsLabel[i]],
      data: _OnlineNpsCount[npsLabel[i]],
      backgroundColor: getBgColor[i],
      borderColor: getBgColor[i],
      stack: i
    })
  }

  const reportData = {
    labels,
    datasets: _reportData,
  };

  return (
    <div>
      <Bar options={options} data={reportData} />
    </div>
  )
}

export default NPSReport